<template>
	<component v-bind:is="iframeModal ? 'layout-blank' : 'layout-splash'">
		<form class="h-full flex flex-col">
			<!-- header title -->
			<div class="bg-green-500 px-6 py-4 text-white">
				<div class="flex justify-between items-baseline pr-4 mr-6">
					<h1 class="text-4xl font-bold" v-if="step == 1 || step == 2">
						<span v-if="locale == 'de'">Profil vervollständigen</span>
						<span v-else>Complete profile</span>
					</h1>
					<h1 class="text-4xl font-bold" v-else>
						<span v-if="locale == 'de'">Fast geschafft</span>
						<span v-else>Almost done</span>
					</h1>

					<div class="text-2xl font-semibold" v-if="step == 1 || step == 2">
						{{ __("Step") }} {{ step }}/{{ steps.length }}
					</div>
				</div>

				<ui-button
					type="blank"
					class="absolute right-5 top-5"
					v-if="iframeModal"
					v-on:click="closeIframeModal()"
				>
					<ui-icon class="h-9 w-9 text-white" name="x" stroke-width="2" />
				</ui-button>
			</div>

			<!-- <ui-wizzard-progress
                :step="step"
                :steps="steps"
                v-on:change="tryGotoStep"
                :key="'PROGRESS_' + step"
            >
                <p
                    v-if="locale == 'de'"
                >Herzlich Willkommen bei cropspot. Herzlich Willkommen bei cropspot. Herzlich Willkommen bei cropspot. Herzlich Willkommen bei cropspot.</p>
                <p
                    v-else
                >Welcome to cropspot. Welcome to cropspot. Welcome to cropspot. Welcome to cropspot. Welcome to cropspot.</p>
            </ui-wizzard-progress>-->

			<!-- main content -->
			<div class="min-h-[30rem]">
				<ui-alert-errors
					v-if="otherErrorMessages.length > 0"
					:messages="otherErrorMessages"
					class="border-b border-red-300 rounded-none"
				/>

				<div v-if="step == 1">
					<div
						class="bg-gray-100 px-6 py-4 text-gray-500 sm:flex sm:items-end sm:justify-between sm:space-x-4"
					>
						<p v-if="locale == 'de'">
							Herzlich Willkommen bei cropspot! Um auf cropspot handeln zu
							können, ergänzen Sie bitte folgende Stammdaten. Ihre Stammdaten
							können sie anschließend in Ihren Profil-Einstellungen einsehen und
							bearbeiten.
						</p>
						<p v-else>
							Welcome to cropspot! To trade on cropspot, please complete the
							following data. You can view and edit your data in your profile
							settings afterwards.
						</p>
					</div>
					<user-edit-base-data
						:user="user"
						:form="form"
						:has-eu-vat-id="false"
						:has-h1="false"
						:can-edit-company-type="true"
					/>
				</div>

				<div class v-if="step == 2">
					<div
						class="bg-gray-100 px-6 py-4 text-gray-500 sm:flex sm:items-end sm:justify-between sm:space-x-4"
					>
						<p v-if="locale == 'de'">
							Wir möchten Sie bestmöglich informieren. Bitte wählen Sie dafür
							Ihre bevorzugten Produkte aus. Sie können Ihre Auswahl
							anschließend in Ihren Profil-Einstellungen einsehen und
							bearbeiten.
						</p>
						<p v-else>
							We would like to inform you in the best possible way. Please
							select the products you prefer. You can view and edit your
							selection afterwards in your profile settings.
						</p>
					</div>
					<user-edit-my-products
						:user="user"
						:form="form"
						:has-h1="false"
						:default-products="['WHEAT', 'RAPE', 'BARLEY']"
					/>
				</div>

				<div class="divide-y divide-gray-200" v-if="step == 3">
					<content-start-modal-not-yet-activated />
				</div>
			</div>

			<!-- button footer -->
			<div class="bg-gray-100 p-6 flex justify-between items-center">
				<div>
					<ui-button
						type="secondary"
						v-if="step == 2"
						v-on:click="step--"
						label="Back"
					/>
				</div>
				<div>
					<ui-button
						v-if="step == 1"
						v-on:click="tryGotoStep(step + 1)"
						label="Next"
					/>

					<ui-button
						v-else-if="step == 2"
						:disabled="submitButtonDisabled"
						v-on:click="submitForm()"
						label="Save"
					/>

					<ui-button v-else v-on:click="closeIframeModal()" label="Close" />
				</div>
			</div>
		</form>
	</component>
</template>

<script>
import UiWizzard from "../components/Ui/Wizzard.vue";
export default {
	mixins: [UiWizzard],
	props: {
		user: {
			type: Object,
			required: true,
		},
		iframeModal: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			form: Vue.observable(this.$inertia.form(this.user)),
			step: 1,
			steps: [{ name: "Base Data" }, { name: "Favorite Products" }],
		};
	},
	methods: {
		onFinish() {
			if (this.user.status == "ACTIVE") {
				this.closeIframeModal();
			} else {
				this.step = 3;
			}
		},
		onSuccess() {
			console.log("ANALYTICS_EMIT_COMPLETE_PROFILE");
			this.$bus.$emit("analytics:complete-profile");
		},
	},
	computed: {
		otherErrorMessages() {
			return Object.values(this.otherErrors || {});
		},
	},
};
</script>
